import { useStaticQuery, graphql } from "gatsby"

const useMediaTypes = () => {
  const { allWpType } = useStaticQuery(graphql`
    query MediaTypes {
      allWpType(
        sort: {name: ASC}
      )
      {
        nodes {
          name
          slug
        }
      }
    }
  `)

  return allWpType.nodes 
}

export default useMediaTypes